module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921132651_T.f9ca8e60.jpg";